const PushNotificationService = {
  APP_CODE: "sliding_puzzle_quest",
  isPushSupported() {
    return false;
  },
  setPushNavigateHandler() {},
  async getAppNotificationPreference() {
    return true;
  },
  async setAppNotificationPreference() {
    return true;
  },
  async syncPushNotificationsIfNeeded() {},
  async enablePushNotifications() {
    return { ok: false, reason: "unsupported" };
  },
  async disablePushNotifications() {},
};

export default PushNotificationService;
